import { render, staticRenderFns } from "./CartList.vue?vue&type=template&id=742e8bec&scoped=true"
import script from "./CartList.vue?vue&type=script&lang=js"
export * from "./CartList.vue?vue&type=script&lang=js"
import style0 from "./CartList.vue?vue&type=style&index=0&id=742e8bec&prod&lang=scss&scoped=true"
import style1 from "./CartList.vue?vue&type=style&index=1&id=742e8bec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742e8bec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RecEngineModule: require('/salonhomepage/client/components/RecEngineModule.vue').default})
